import { RiskLevel } from 'dashboard/models/verification-check';
import Sticker, { StickerProps } from 'design-system/components/Sticker';

export const RISK_LEVEL_VARIANT_MAP: Record<RiskLevel, StickerProps['variant']> = {
  [RiskLevel.Minimal]: 'success',
  [RiskLevel.Low]: 'success',
  [RiskLevel.Medium]: 'caution',
  [RiskLevel.High]: 'danger',
};

export const RISK_LEVEL_LABEL_MAP: Record<RiskLevel, string> = {
  [RiskLevel.Minimal]: 'Minimal',
  [RiskLevel.Low]: 'Low',
  [RiskLevel.Medium]: 'Medium',
  [RiskLevel.High]: 'High',
};

interface RiskLevelStickerProps {
  id?: string;
  riskLevel: RiskLevel;
}

const RiskLevelSticker = ({ riskLevel }: RiskLevelStickerProps) => (
  <Sticker variant={RISK_LEVEL_VARIANT_MAP[riskLevel]}>{RISK_LEVEL_LABEL_MAP[riskLevel]}</Sticker>
);

export default RiskLevelSticker;
